var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8847 7.88461H10.9616C10.6217 7.88461 10.3462 8.16013 10.3462 8.5V15.8846C10.3462 16.2244 10.6217 16.5 10.9616 16.5H15.8847C16.2245 16.5 16.5 16.2244 16.5 15.8846V8.5C16.5 8.16013 16.2245 7.88461 15.8847 7.88461Z",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8847 0.5H10.9616C10.6217 0.5 10.3462 0.775518 10.3462 1.11538V3.58923C10.3462 3.9291 10.6217 4.20462 10.9616 4.20462H15.8847C16.2245 4.20462 16.5 3.9291 16.5 3.58923V1.11538C16.5 0.775518 16.2245 0.5 15.8847 0.5Z",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03846 0.5H1.11538C0.775518 0.5 0.5 0.775518 0.5 1.11538V8.5C0.5 8.83986 0.775518 9.11538 1.11538 9.11538H6.03846C6.37833 9.11538 6.65385 8.83986 6.65385 8.5V1.11538C6.65385 0.775518 6.37833 0.5 6.03846 0.5Z",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03846 12.7954H1.11538C0.775518 12.7954 0.5 13.0708 0.5 13.4108V15.8846C0.5 16.2244 0.775518 16.5 1.11538 16.5H6.03846C6.37833 16.5 6.65385 16.2244 6.65385 15.8846V13.4108C6.65385 13.0708 6.37833 12.7954 6.03846 12.7954Z",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5a87271c273a3566d928741fb5e90cfd.svg";
export { ForwardRef as ReactComponent };